var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconLoupe = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "currentColor",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6298 12.6454C10.4022 13.6484 8.83387 14.25 7.125 14.25C3.18997 14.25 0 11.06 0 7.125C0 3.18997 3.18997 0 7.125 0C11.06 0 14.25 3.18997 14.25 7.125C14.25 8.83387 13.6484 10.4022 12.6454 11.6298C12.9671 11.6 13.2992 11.7082 13.5455 11.9545L18.0455 16.4545C18.4848 16.8938 18.4848 17.6062 18.0455 18.0455C17.6062 18.4848 16.8938 18.4848 16.4545 18.0455L11.9545 13.5455C11.7082 13.2992 11.6 12.9671 11.6298 12.6454ZM12 7.125C12 9.81739 9.81739 12 7.125 12C4.43261 12 2.25 9.81739 2.25 7.125C2.25 4.43261 4.43261 2.25 7.125 2.25C9.81739 2.25 12 4.43261 12 7.125Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconLoupe);
export default ForwardRef;